module.exports = __webpack_public_path__ + "static/media/delete_x_icon.69683ee8.svg";